<template>
	<button
		type="button"
		class="mode-toggle"
		:aria-label="mode === 'dark' ? 'Uključi svijetli način' : 'Uključi tamni način'"
		@click="toggleMode"
	>
		{{ mode === 'dark' ? '☀' : '☾' }}
	</button>
</template>

<script setup>
import { useTheme } from '../../composables/useTheme.js'

const { mode, toggleMode } = useTheme()
</script>

<style lang="scss" scoped>
.mode-toggle {
	width: 30px;
	height: 30px;
	flex: none;
	border-radius: 50%;
	border: 1px solid var(--color-border);
	background: var(--color-surface);
	color: var(--color-text);
	cursor: pointer;
	font-size: 0.9rem;
	line-height: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0;
}
</style>
